import React, { useEffect, useState } from "react";
import Toastify, { notifyError, notifySuccess } from "../../../utils/tostfy";
import MasterSuccessModal from '../MasterSuccessModal';
import { Link } from "react-router-dom";
import { handleApiCall } from "../../../apis";
import { endpoint } from "../../../utils/endpoints";
import EditIcon from '../../../assets/image/edit-icon.svg'
import DeleteIcon from '../../../assets/image/delete-icon.svg'
import EyeIcon from '../../../assets/image/eye-icon.svg'
import LeftAngle from '../../../assets/image/left-angle.svg'
import RightAngle from '../../../assets/image/right-angle.svg'
import PermissionGate from '../../../Components/PermissionGate/PermissionGate';
import { MODULES } from '../../../utils/permissions';
import { SEARCH_MAX_LENGTH, clampSearchInput } from "../../../utils/search";
import PageNumberInput from "../../../Components/Pagination/PageNumberInput";
const RouteMaster = () => {
  const [routes, setRoutes] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [statusUpdatingId, setStatusUpdatingId] = useState("");
  const [successModal, setSuccessModal] = useState({ open: false, message: "" });
  const openMasterSuccess = (message) =>
    setSuccessModal({ open: true, message: message || "Saved successfully" });
  const closeMasterSuccess = () => setSuccessModal({ open: false, message: "" });

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search), 400);
    return () => clearTimeout(t);
  }, [search]);
  const searchForApi = (() => {
    const s = clampSearchInput(debouncedSearch).trim();
    if (!s) return '';
    if (/^\+?[\d\s-]+$/.test(s)) return s.replace(/\D/g, '');
    return s;
})();
  const fetchRouteList = async () => {
    setListLoading(true);
    try {
      const response = await handleApiCall(
        "get",
        `${endpoint.listOfRoute}?search=${encodeURIComponent(searchForApi)}&page=${currentPage}&limit=${itemsPerPage}`,
        {}
      );
      if (response?.data?.code === 200) {
        const d = response?.data?.data || {};
        const mapped = (d?.route_data || []).map((r) => ({
          id: r?._id || "",
          route_ref_id:
            r?.route_ref_id != null && String(r.route_ref_id).trim() !== ""
              ? String(r.route_ref_id)
              : "-",
          companyId: r?.company_id?._id || "",
          company: r?.company_id?.name || "-",
          companyLocationId: r?.company_location_id?._id || "",
          companyLocation: r?.company_location_id?.name || "-",
          miplLocationId: r?.mipl_location_id?._id || "",
          idealAverage: `${r?.ideal_average ?? "-"}`,
          singleDriverTripAmount: r?.single_driver_trip_amount ?? "",
          dualDriverTripAmount: r?.dual_driver_trip_amount ?? "",
          statusCode: r?.status === 1 ? 1 : 0,
          status: r?.status === 1 ? "Active" : "Inactive",
        }));
        setRoutes(mapped);
        setTotalRecords(d?.total ?? mapped.length);
        setTotalPages(Math.max(1, d?.total_pages ?? 1));
      } else {
        const errMsg =
          response?.response?.data?.errorMessage ||
          response?.response?.data?.message ||
          response?.data?.message ||
          "Failed to load routes";
        notifyError(errMsg);
      }
    } catch {
      notifyError("Failed to load routes");
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchRouteList();
  }, [debouncedSearch, currentPage, itemsPerPage]);

  const handleRouteStatusToggle = async (routeId, currentStatus) => {
    const nextStatus = currentStatus === 1 ? 0 : 1;
    if (!routeId) return;
    setStatusUpdatingId(routeId);
    try {
      const response = await handleApiCall("put", endpoint.updateStatusRoute, {
        route_id: routeId,
        status: nextStatus,
      });
      if (response?.data?.code === 200) {
        setRoutes((prev) =>
          prev.map((r) =>
            r.id === routeId
              ? {
                  ...r,
                  statusCode: nextStatus,
                  status: nextStatus === 1 ? "Active" : "Inactive",
                }
              : r
          )
        );
        notifySuccess(response?.data?.message || "Route status updated");
        return;
      }
      const errMsg =
        response?.response?.data?.errorMessage ||
        response?.response?.data?.message ||
        response?.data?.message ||
        "Could not update route status";
      notifyError(errMsg);
    } catch {
      notifyError("Something went wrong. Please try again.");
    } finally {
      setStatusUpdatingId("");
    }
  };

  const displayFrom = totalRecords === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const displayTo = Math.min(currentPage * itemsPerPage, totalRecords);

  const showInitialEmptyState = !listLoading && totalRecords === 0 && !debouncedSearch;

  return (
    <>
    {/* Empty State */}
    <Toastify/>
      {showInitialEmptyState ? (
        <div className="bg-white h-[400px] flex flex-col items-center justify-center rounded max-w-2xl mx-auto font-UbuntuRegular shadow-sm">
          <h2 className="text-2xl font-semibold mb-2">
            No routes have been added to the list yet.
          </h2>
          <p className="text-gray-500 mb-4 text-lg">
            Please click on the "Add Route" button to add a new route.
          </p>
          <PermissionGate module={MODULES.MASTER} action="add">
            <Link to="/route-master/add-route" className="!bg-primary text-white px-6 py-3 rounded min-w-64 text-center">
              Add Route
            </Link>
          </PermissionGate>
        </div>
      ) : (
        <>

          <div className="tab-pane-content md:mt-7 mt-3">
                <div className='flex gap-x-2.5 md:mb-4 mb-3'>
                    <input
                        type="text"
                        placeholder="Search..."
                        className="border px-3 py-2 rounded-lg outline-none text-sm searchIcon bg-white focus:!shadow-sm"
                        value={search}
                        maxLength={SEARCH_MAX_LENGTH}

                        onChange={(e) => setSearch(clampSearchInput(e.target.value))}
                    />
                    <PermissionGate module={MODULES.MASTER} action="add">
                        <Link className="btn btn-danger ml-auto" to="/route-master/add-route">
                            + Add New <span className="max-[767px]:hidden">Route</span>
                        </Link>
                    </PermissionGate>
                </div>
                {/* Table */}
                <div className="common-table-wrapper m-0">
                    <div className="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Route Id</th>
                                    <th>Company</th>
                                    <th>Company Location</th>
                                    <th>Ideal Average</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody className='max-[767px]:[&_td]:!py-2'>
                                {listLoading && (
                                    <tr>
                                        <td colSpan={7} className="text-center py-4 text-gray-500">
                                            Loading...
                                        </td>
                                    </tr>
                                )}
                                {!listLoading && routes.map((driver, index) => (
                                    <tr key={driver.id}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                        <td>{driver.route_ref_id}</td>
                                        <td>{driver.company}</td>
                                        <td>{driver.companyLocation}</td>
                                        <td>{driver.idealAverage}</td>
                                        <td>{driver.status}</td>
                                        <td>
                                            <div className="flex items-center justify-center gap-2">
                                                <PermissionGate module={MODULES.MASTER} action="edit">
                                                    <label className="relative inline-flex items-center cursor-pointer w-9 min-w-9 h-5 bg-[#E11818] rounded-full my-0 [&:has(input:checked)]:bg-[#17B517] [&:has(input:checked)_.absolute]:!left-[17px] transition-all">
                                                        <input
                                                            type="checkbox"
                                                            className="hidden"
                                                            checked={driver.statusCode === 1}
                                                            onChange={() => handleRouteStatusToggle(driver.id, driver.statusCode)}
                                                            disabled={statusUpdatingId === driver.id || listLoading}
                                                        />
                                                        <div className="absolute left-[3px] top-0.5 w-4 h-4 bg-white rounded-full transition-all"></div>
                                                    </label>
                                                </PermissionGate>
                                                <PermissionGate module={MODULES.MASTER} action="edit">
                                                    <Link
                                                        to="/route-master/add-route"
                                                        state={{ routeData: driver, mode: "edit" }}
                                                    >
                                                        <img src={EditIcon} alt="Edit" className='h-7 min-w-[22px]'/>
                                                    </Link>
                                                </PermissionGate>
                                                <PermissionGate module={MODULES.MASTER} action="view">
                                                    <Link to={`/route-master/view-route?route_id=${encodeURIComponent(driver.id)}`}><img src={EyeIcon} alt="View" className='h-7 min-w-[22px]'/></Link>
                                                </PermissionGate>
                                                {/* <span>
                                                    <img src={DeleteIcon} alt="Delete" className='h-7 min-w-[22px]'/>
                                                </span> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {!listLoading && routes.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="text-center py-4 text-gray-500">
                                            No routes found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Pagination */}
                <div className="flex gap-x-4 items-center md:mt-4 mt-3">
                    <select
                        className='p-2 shadow-sm outline-none max-[767px]:text-xs'
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                    </select>
                    {/* Total Records */}
                    <div className="text-xs md:text-sm text-gray-500 ml-auto">
                        {listLoading
                            ? "—"
                            : totalRecords === 0
                                ? "0 records found"
                                : `${displayFrom}-${displayTo} of ${totalRecords} records found`}
                    </div>
                    {/* Pagination Controls */}
                    <div className="flex items-center gap-2 md:pr-8">
                        <button
                            type="button"
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={listLoading || currentPage === 1}
                            className={`!bg-primary text-white md:w-[35px] md:h-[35px] w-[25px] h-[25px] rounded-full disabled:opacity-50 inline-flex justify-center items-center ${currentPage===1 ? '' : 'cursor-pointer'}`}
                        >
                            <img src={LeftAngle} className='invert grayscale brightness-100'/>
                        </button>
                        <PageNumberInput
              page={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              className="h-[35px] w-10 md:w-12 rounded border border-gray-300 text-center text-sm font-UbuntuMedium shadow-sm outline-none disabled:cursor-not-allowed disabled:bg-gray-100 disabled:opacity-70"
            />
                        <span className="text-sm text-gray-600 text-nowrap">
                            of {totalPages}
                        </span>
                        <button
                            type="button"
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={listLoading || currentPage === totalPages || totalRecords === 0}
                            className={`!bg-primary text-white md:w-[35px] md:h-[35px] w-[25px] h-[25px] rounded-full disabled:opacity-50 inline-flex justify-center items-center ${currentPage===1 ? '' : 'cursor-pointer'}`}
                        >
                            <img src={RightAngle} className='invert grayscale brightness-100'/>
                        </button>

                    </div>
                </div>
            </div>
        </>
      )}
      <MasterSuccessModal
        open={successModal.open}
        message={successModal.message}
        onClose={closeMasterSuccess}
      />
    </>
  );
};

export default RouteMaster;
